"use client";
import { useGetCurrenciesQuery } from "@/api/AppApi/services/company";
import Flag from "@/app/components/lib/Flag";
import {
  currencyAtom,
  currencyChangedCodeAtom,
  currencyCodeAtom,
  getCurrentCurrencyFromCode,
} from "@/hooks/currencyAtom";
import { useTranslation } from "@/hooks/localization/useTranslations";
import useIsClient from "@/hooks/useIsClient";
import { Row } from "@/utils/bootstrap";
import { storeCurrencyCookie } from "@/utils/functions/cookieOperations";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import SvgCurrency from "../common-header-icons/SvgCurrency";
import CommonDropdownMenu from "../menu/CommonDropdownMenu";
import MenuLink from "../menu/MenuLink";

interface Props {
  mobile?: boolean;
}
const CurrencyChanger: React.FC<Props> = ({ mobile = false }) => {
  const getCurrncies = useGetCurrenciesQuery();
  const currencies = getCurrncies?.data?.result;
  const t = useTranslation();
  const [changed, setChanged] = useAtom(currencyChangedCodeAtom);
  const [currentCurrCode, setCurrentCurrCode] = useAtom(currencyCodeAtom);
  const [currentCurrency] = useAtom(currencyAtom);
  const [selectedCurrency, setSelectedCurrency] = useState(currentCurrency);
  const isClient = useIsClient();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);
  useEffect(() => {
    setSelectedCurrency(currentCurrency);
  }, [currentCurrency?.code]);

  if (!ready || !currencies) return null;
  if (!isClient || !!(currencies && currencies?.length === 1)) return null;
  return (
    <CommonDropdownMenu
      reversed
      isMobile={mobile}
      onSelect={(e) => {
        if (changed) return;
        setChanged(true);
        setCurrentCurrCode(e);
        const currency = getCurrentCurrencyFromCode(currencies!, e);
        // setCurrentCurrency(currency!);
        setSelectedCurrency(currency!);
        storeCurrencyCookie(e);
        fetch("/clear-cache", {
          method: "POST",
          headers: {
            "Content-type": "application/json",
          },
          body: JSON.stringify({ keys: [location.hostname] }),
        })
          .then(() => {
            // router.refresh();
            // queryClient.clear();
            // queryClient.invalidateQueries();
            // queryClient.refetchQueries({ stale: true });
            location.reload();
          })
          .catch(() => {});
      }}
      title={{
        text: mobile ? t?.currency : selectedCurrency?.symbol,
        Svg: mobile ? (
          <SvgCurrency />
        ) : (
          <Flag countryCode={selectedCurrency?.code?.slice(0, 2)} width={18} />
        ),
      }}
      down
    >
      {!mobile && (
        <Row className="dropdown-inner-title">{t?.select_currency}</Row>
      )}
      {currencies?.map((currency, key) => (
        <MenuLink
          key={key}
          eventKey={currency?.code}
          active={currency?.code === currentCurrCode}
          isMobile={mobile}
          title={{
            Svg: <Flag countryCode={currency?.code.slice(0, 2)} width={18} />,
            text: `${currency?.symbol} - ${currency?.name}`,
          }}
        />
      ))}
    </CommonDropdownMenu>
  );
};

export default CurrencyChanger;
